import { inject, Injectable } from '@angular/core';

import { Observable, shareReplay } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

export type AnalyticsTrackingData = {
  membership_id: number;
  company_id: number;
  company_name: string;
  created_at: number;
  first_name: string;
  id: number;
  identity_hash: string;
  ios_identity_hash: string;
  last_name: string;
  name: string;
};

@Injectable({ providedIn: 'root' })
export class AnalyticsTrackingDataService {
  #httpApi = inject(HttpApiService);

  #data$ = this.#httpApi
    .get(`analytics/tracking_data`, {}, { headers: { 'x-json-accent': [] } })
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  // we're unsetting x-json-accent here to avoid mismatch between data synced from backend & frontend
  public fetch(): Observable<AnalyticsTrackingData> {
    return this.#data$;
  }
}
